import { Button } from "@/components/ui/button";

const links = [
  { label: "Built to Roam", href: "#features" },
  { label: "Specs", href: "#models" },
  { label: "Action", href: "#videos" },
  { label: "Owners", href: "#testimonials" },
  { label: "FAQ", href: "#faq" },
];

export default function Header() {
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-md bg-background/70 border-b border-border/60"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 h-16 flex items-center justify-between">
        <a href="#top" data-testid="brand-logo" className="flex items-center gap-2.5">
          <img
            src="https://customer-assets.emergentagent.com/job_aussie-4wd-hub/artifacts/u1tlocwk_Overlander%20mobility%20logo%20%28no%20text%29%20%282%29.png"
            alt="Overlander Mobility"
            className="h-9 w-9 object-contain"
          />
          <span className="font-display font-bold tracking-tight uppercase text-sm">
            Overlander <span className="text-primary">Mobility</span>
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-xs uppercase tracking-[0.18em] font-semibold text-foreground/70 hover:text-primary transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="relative inline-block">
          <span
            aria-hidden="true"
            data-testid="header-booked-out-banner"
            className="absolute -top-2.5 -right-3 z-10 rotate-[8deg] bg-foreground text-primary text-[9px] font-black uppercase tracking-[0.1em] px-1.5 py-0.5 rounded-sm shadow-lg border border-white/10 pointer-events-none whitespace-nowrap"
          >
            &apos;26 Booked
          </span>
          <Button
            asChild
            data-testid="header-quote-btn"
            className="rounded-sm uppercase tracking-wider font-bold text-xs px-5"
          >
            <a href="#test-drive">Book a Trial</a>
          </Button>
        </div>
      </div>
    </header>
  );
}
